import type { DayOfWeek } from '../../types';

// View mode options
export const viewModes = [
  { id: 'whole-school', label: 'Whole School', description: 'View complete school timetable' },
  { id: 'teacher', label: 'By Teacher', description: 'View individual teacher schedules' },
  { id: 'year-group', label: 'By Year Group', description: 'View year group timetables' },
  { id: 'room', label: 'By Room', description: 'View room allocation schedules' },
  { id: 'subject', label: 'By Subject', description: 'View subject distribution' },
  { id: 'day', label: 'By Day', description: 'View single day overview' },
] as const;

// Color scheme options for lessons
export const colorSchemes = [
  { id: 'subject', label: 'By Subject', description: 'Color lessons by subject' },
  { id: 'category', label: 'By Category', description: 'Color lessons by subject category' },
  { id: 'teacher', label: 'By Teacher', description: 'Color lessons by teacher' },
] as const;

// Statistics for the view
export interface TimetableViewStats {
  totalLessons: number;
  teachersScheduled: number;
  roomsUsed: number;
  conflictCount: number;
  coveragePercentage: number;
  freePeriods: number;
}

export const mockViewStats: TimetableViewStats = {
  totalLessons: 248,
  teachersScheduled: 85,
  roomsUsed: 42,
  conflictCount: 3,
  coveragePercentage: 98.5,
  freePeriods: 127,
};

// Quick filter presets
export interface FilterPreset {
  id: string;
  name: string;
  filters: {
    day?: DayOfWeek;
    teacherId?: string;
    yearGroupId?: string;
    roomId?: string;
    subjectId?: string;
  };
}

export const mockFilterPresets: FilterPreset[] = [
  {
    id: 'preset-monday',
    name: 'Monday Overview',
    filters: { day: 'monday' },
  },
  {
    id: 'preset-year10',
    name: 'Year 10 Timetable',
    filters: { yearGroupId: 'year-10' },
  },
  {
    id: 'preset-math-dept',
    name: 'Mathematics Lessons',
    filters: { subjectId: 'subject-math' },
  },
  {
    id: 'preset-science-labs',
    name: 'Science Labs Usage',
    filters: { roomId: 'room-sci-lab-1' },
  },
];

// Export format options
export const exportOptions = [
  { id: 'pdf', label: 'PDF Document', icon: 'picture_as_pdf' },
  { id: 'excel', label: 'Excel Spreadsheet', icon: 'table_chart' },
  { id: 'csv', label: 'CSV File', icon: 'description' },
] as const;

